import { getStore } from '../store/store';
export default function isGhostTextVisible() {
    return getStore().ghostText.length > getStore().searchText.length;
}
//# sourceMappingURL=isGhostTextVisible.js.map